document.addEventListener('DOMContentLoaded', function() {
    // Select all product cards that have variants
    var productCardsWithVariants = document.querySelectorAll('.productcard[data-has-variants="true"]');
  
    // Loop through each product card with variants
    productCardsWithVariants.forEach(function(productCard) {
      // Get the add to cart button
      var addToCartButton = productCard.querySelector('.productcard--add-cart');
      // Get the product ID from the data-id attribute of the addToCartButton
      var productId = addToCartButton.getAttribute('data-id');
      // Get the variant dropdowns
      var sizeDropdown = productCard.querySelector('.product-variant__select-container[data-type="Montants"] select');
      var perfumeDropdown = productCard.querySelector('.product-variant__select-container[data-type="Parfum"] select');
      var colorDropdown = productCard.querySelector('.product-variant__select-container[data-type="Coloris"] select');
      var protocoleDropdown = productCard.querySelector('.product-variant__select-container[data-type="Protocoles Anti-chute"] select');
  
      // Get the add to cart button and hidden input field
      var addToCartButton = productCard.querySelector('.productcard--add-cart');
      var hiddenInputField = productCard.querySelector('.main-product-detail-buy input[name="id"]');
  
      // Get the image elements within the current product card
      var imageElements = Array.from(productCard.querySelectorAll('.productcard_images img'));
  
      // Sort the image elements based on their class names
      imageElements.sort(function(a, b) {
        var aIndex = parseInt(a.className.match(/productcard_image-(\d+)/)[1], 10);
        var bIndex = parseInt(b.className.match(/productcard_image-(\d+)/)[1], 10);
        return aIndex - bIndex;
      });
  
      // Function to update the price, hidden input field, and displayed image when a variant is selected
      var updateVariant = function(variantDropdown, productCard) {
        var selectedOption = variantDropdown.options[variantDropdown.selectedIndex];
        var selectedTitle = variantDropdown.options[variantDropdown.selectedIndex].value;
        var variantsElement = productCard.querySelector('#variants');
        var variants = JSON.parse(variantsElement.value);
  
        var selectedVariant = variants.find(function(variant) {
          return variant.title === selectedTitle;
        });
        var variantId = selectedVariant.id;
  
        var dataId = selectedOption.getAttribute('data-id');
        var parts = dataId.split(';');
        var price = parts[3];
  
        price = parseFloat(price.replace('|', '').replace(' €', '').replace(',', '.'));

  
        if (variantDropdown === sizeDropdown) {
          // Get current shop currency from Shopify
          var currentCurrency = window.Shopify?.currency?.active || 'EUR';
          var locale = currentCurrency === 'CHF' ? 'de-CH' : 'fr-FR';
          var formattedPrice = price.toLocaleString(locale, {
            style: 'currency',
            currency: currentCurrency
          });

          addToCartButton.textContent = 'Ajouter au panier - ' + formattedPrice;
        }
  
        if (variantDropdown === protocoleDropdown) {
          var priceMatch = selectedTitle.match(/\((\d+[,.]\d+)€\)/);
          if (priceMatch) {
            var price = parseFloat(priceMatch[1].replace(',', '.'));
            // Get current shop currency from Shopify
            var currentCurrency = window.Shopify?.currency?.active || 'EUR';
            var locale = currentCurrency === 'CHF' ? 'de-CH' : 'fr-FR';
            var formattedPrice = price.toLocaleString(locale, {
              style: 'currency',
              currency: currentCurrency
            });

            addToCartButton.textContent = 'Ajouter au panier - ' + formattedPrice;
          } else {
            console.log("Price not found in selectedTitle: ", selectedTitle);
          }
        }
  
        var variantInput = productCard.querySelector(`input#variant-${productId}`);
        if (variantInput) {
          variantInput.value = variantId;

        } else {
          console.log(`Input element with id 'variant-${productId}' not found`);
        }
  
        // Update the displayed image
        var selectedIndex = variantDropdown.selectedIndex;

  
        imageElements.forEach(function(img, index) {

          img.style.display = (index === selectedIndex) ? 'block' : 'none';
        });
      };
  
      // Set up event listeners for changes to the variant dropdowns
      if (sizeDropdown) {
        sizeDropdown.addEventListener('change', function() {

          updateVariant(sizeDropdown, productCard);
        });
      }
      if (perfumeDropdown) {
        perfumeDropdown.addEventListener('change', function() {

          updateVariant(perfumeDropdown, productCard);
        });
      }
      if (colorDropdown) {
        colorDropdown.addEventListener('change', function() {

          updateVariant(colorDropdown, productCard);
        });
      }
      if (protocoleDropdown) {
        protocoleDropdown.addEventListener('change', function() {

          updateVariant(protocoleDropdown, productCard);
        });
      }
    });
  });